import React from 'react';
import PropTypes from 'prop-types';
import isResizable from '../../../../mixins/resizable';
import { ArrowLeft } from 'lucide-react';

// Modules
import Window from '../../../../../modules/window';

// Models
import Profile from '../../../../../models/v2/profile';

// Base
import Badge from '../../../base/badge';
import Button from '../../../base/button';
import Separator from '../../../base/separator';

// Related Components
import LogoutLogo from '../../../agents/subscribe/logout_logo';
import Progress from './progress';

class DiscoverySource extends React.Component {
  static SOURCES = {
    'referral': 'Referral',
    'oomple_team': 'Oomple Team',
    'linked_in': 'LinkedIn',
    'google': 'Google',
    'twitter': 'Twitter',
    'facebook': 'Facebook',
    'word_of_mouth': 'Word of Mouth',
    'other': 'Other',
  };

  static propTypes = {
    user: PropTypes.object.isRequired,
    onSetView: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      user: props.user,
      sending: false,
      loading: true,
      discoverySource: '',
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const { user } = this.props;
    Profile
      .url(`/api/v2/users/${user.id}`)
      .find('profile')
      .then((profile) => {
        this.setState({
          loading: false,
          profile,
        })
      })
  }

  get isDisabled() {
    const { loading, sending, discoverySource } = this.state;
    return loading || sending || !discoverySource;
  }

  handleClick = (discoverySource) => {
    this.setState({ discoverySource });
  }

  isSelected = (source) => {
    const { discoverySource } = this.state;
    return discoverySource === source;
  }

  handleNext = () => {
    const { onSetView } = this.props;
    const { profile, discoverySource, sending } = this.state;

    if (sending) return;

    this.setState({ sending: true }, () => {
      const data = {
        id: profile.id,
        discovery_source: discoverySource,
      };
      (new Profile(data))
        .save()
        .then((_profile) => {
          onSetView('pricing')
        })
        .catch((errors) => {
          this.setState({
            sending: false,
          })
          Window.flash.error(errors);
        });
    });
  }

  render() {
    const { onSetView } = this.props;

    return (
      <React.Fragment>
        <div className='height-60 margin-bottom-70'>
          <LogoutLogo />
        </div>
        <div className='width-560 margin-center relative'>
          <div className='absolute left--45'>
            <ArrowLeft {...{
              size: 24,
              onClick: () => onSetView('industries'),
              className: 'cursor-pointer',
            }} />
          </div>
          <div className='width-400 padding-top-25'>
            <Progress {...{
              value: 3,
              max: 4,
            }} />
          </div>
          <div className='margin-bottom-10 xlg-font semi-bold line-height-26'>How did you hear about us?</div>
          <Separator className='margin-top-0 margin-bottom-10' />
          <div className='width-520'>
            {
              Object.keys(DiscoverySource.SOURCES).map((source) => {
                const selected = this.isSelected(source);
                return <Badge {...{
                  key: source,
                  text: DiscoverySource.SOURCES[source],
                  onClick: () => this.handleClick(source),
                  selected,
                  hoverable: false,
                  selectable: true,
                }} />
              })
            }
            <div className='margin-top-40'>
              <Button {...{
                id: 'continue',
                text: 'Continue',
                onClick: this.handleNext,
                className: 'height-45 med-font vertical-align line-height-45',
                block: true,
                disabled: this.isDisabled,
              }} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default isResizable(DiscoverySource);
